@if (audioSource) {
  <div class="audio-player">
    <div class="audio-player__controls">
      <button
        class="audio-player__action-button"
        [class.audio-player__action-button--medium]="isMobile"
        (click)="rewind(10)"
      >
        <img class="audio-player__action-icon" src="assets/icons/reverse-10.svg" alt="rewind icon" />
      </button>

      <button
        class="audio-player__action-button audio-player__action-button--medium"
        [class.audio-player__action-button--large]="isMobile"
        (click)="togglePlay()"
      >
        @if (audioPlayer.paused) {
          <span class="audio-player__action-icon audio-player__play-icon"></span>
        } @else {
          <span class="audio-player__action-icon audio-player__pause-icon"></span>
        }
      </button>

      <button
        class="audio-player__action-button"
        [class.audio-player__action-button--medium]="isMobile"
        (click)="forward(10)"
      >
        <img class="audio-player__action-icon" src="assets/icons/forward-10.svg" alt="forward icon" />
      </button>
    </div>

    <div class="audio-player__audio-progress-section">
      <input
        class="audio-player__audio-progress"
        type="range"
        min="0"
        step="any"
        cvAudioProgressBackground
        [rangeValue]="audioPlayer.currentTime"
        [duration]="audioPlayer.duration"
        [max]="audioPlayer.duration"
        [(ngModel)]="audioPlayer.currentTime"
        (change)="onTimeRangeChange($event)"
      />
      <div
        class="audio-player__time-container"
        [attr.data-current-time]="audioPlayer.currentTime | formatTime"
        [attr.data-total-time]="audioPlayer.duration | formatTime"
      ></div>
    </div>

    <button
      class="audio-player__icon-mute-button"
      [class.audio-player__icon-mute-button--medium]="isMobile"
      [class.mb-20]="isMobile"
      (click)="audioPlayer.muted = !audioPlayer.muted"
    >
      @if (audioPlayer.muted) {
        <img class="audio-player__action-icon" src="assets/icons/volume-xmark-solid.svg" alt="volume xmark icon" />
      } @else {
        <img class="audio-player__action-icon" src="assets/icons/volume-high-solid.svg" alt="volume high icon" />
      }
    </button>

    <audio
      #audioPlayer
      [src]="audioSource"
      (timeupdate)="timeUpdate.emit(audioPlayer.currentTime)"
      (loadedmetadata)="cdr.markForCheck()"
    ></audio>
  </div>
}
